import { render, staticRenderFns } from "./detailLeads.vue?vue&type=template&id=1a4e004f&"
import script from "./detailLeads.vue?vue&type=script&lang=js&"
export * from "./detailLeads.vue?vue&type=script&lang=js&"
import style0 from "./detailLeads.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports